import { render, staticRenderFns } from "./printHistoriaInfancia.vue?vue&type=template&id=58f607ce&scoped=true&"
import script from "./printHistoriaInfancia.vue?vue&type=script&lang=js&"
export * from "./printHistoriaInfancia.vue?vue&type=script&lang=js&"
import style0 from "./printHistoriaInfancia.vue?vue&type=style&index=0&id=58f607ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f607ce",
  null
  
)

export default component.exports